/**
 * Created by zjy on 2017/7/31.
 */
import axios from 'axios'
export default{

  
  install(vue){;
  var iAxios = axios.create({
    baseURL:"http://59.110.64.112:8080",
  });
    vue.prototype.$http = iAxios;
  }

}

 
  


// WEBPACK FOOTER //
// ./src/axios.js